<script>
import appConfig from "@/app.config";
import Swal from "sweetalert2";
//import { tableData } from "./dataAdvancedtable";
import axios from 'axios';

import CustomerLocation from "../management/customerLocation";
import CustomerContact from "../management/customerContact";
import CategoryMaintenance from "../equipment/categoryMaintenance";
import CategoryCleaning from "../equipment/categoryCleaning";
import CategoryCalibration from "../equipment/categoryCalibration";

/**
 * Advanced table component
 */
export default {
  name: "log",
  page: {
    title: "Logs",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { CustomerLocation, CustomerContact, CategoryMaintenance, CategoryCleaning, CategoryCalibration },
  props: {
    menu:       String,
    entity:     String,
    addLink:    String,
    modalType:  String,
    actions:    Object,
    component:  String,
    idRecord:   String,
    idEntity:   [String, Number, null],
    datas:      Array,
    columns:    Array,
  },
  data() {
    return {
      id: 0,
      componentKey: 0,
      minimized: true,
      record:{},
      tableData: [],
      title: "",
      tableName: "",
      addAction: "",
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Advanced",
          active: true
        }
      ],
      rows: 1,
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id_site",
      sortDesc: true,
      fields: [],
      fixedEntity: "",
      modalShow: false,
      visible: true,

      unit: '',
      units : {
        'industry':     'industries',
        'process':      'processes',
        'product':      'products',
        'customer':     'customers',
        'category':     'categories',
        'brand':        'brands',
        'model':        'models',
        'equipment':    'equipments',
        'document':     'documents',
        'master':       'masters',
        'template':     'templates',
        'maintenance':  'maintenances',
        'cleaning':     'cleanings',
        'calibration':  'calibrations',
      },
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    
  },
  //As the component us re-used for various modules, this WATCHER allows to reload the data.
  watch:{
    "entity": function(oldvalue, newvalue){
      if(oldvalue !== newvalue){
        this.setInit();
      }
    },
    "datas": function(oldvalue, newvalue){
      if(oldvalue !== newvalue){
        this.setInit();
      }
    },
    "rows": function(oldvalue, newvalue){
      return newvalue;
    }
  },
  created(){
    if(localStorage){
      this.user = JSON.parse( localStorage.getItem('user') );
    }
  },
  mounted() {
    this.componentKey += 1;
    // Set the initial number of items
    this.rows  = this.datas.length;
    this.setInit();
  },
  methods: {
    getFields(){
      let app = this;
      //let ent = this.entity + "s";
      axios
      .get(
        'http://gocomply.unaux.com/dist/mvw/controllers/'+this.units[this.entity]+'.php',
        {
          params: {
            request: 'getFields',
          }
        }
      )
      .then(response => {
        if( response.statusText == "OK" ){
          app.fields = response.data;
          app.sortBy = response.data[0].key;
        }else{
          Swal.fire("Ooops!", "It was nor possible to load data! Please load this module again.", "error");
        }
      }).catch(e =>{
        Swal.close();
        if( e.response.status == 500){ app.$router.push({ name: 'Error-500' }); }
        if( e.response.status == 404){ app.$router.push({ name: 'Error-404' }); }
      });
    },

    getRecords(customRequest=""){
      Swal.fire({
        title: "Loading data.",
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });
      let app = this;
      //let ent = this.entity + "s";
      axios
      .get(
        'http://gocomply.unaux.com/dist/mvw/controllers/'+this.units[this.entity]+'.php',
        {
          params: {
            request: (customRequest != "")?customRequest:'get'+this.capitalLetter(this.units[this.entity]).replace(" ","")+"ForLog",
          }
        }
      )
      .then(response => {
        if( response.statusText == "OK" ){
          app.tableData = response.data;
          Swal.close();
        }else{
          Swal.fire("Ooops!", "It was not possible to load data! Please load this module again.", "error");
        }
      }).catch(e =>{
        Swal.close();
        if( e.response.status == 500){ app.$router.push({ name: 'Error-500' }); }
        if( e.response.status == 404){ app.$router.push({ name: 'Error-404' }); }
      });
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },

    capitalLetter(string) {
      return ( string.charAt(0).toUpperCase() + string.slice(1) ).replace("-", " ");
    },


    setBreadcrum(){
      this.items = [
        {text: this.menu, href:"/"},
        {text: this.title.replace(" log", ""), active:true}
      ]
    },

    closeModal(component){
      this.$bvModal.hide(component);

      this.$emit('reload');
    },

    setInit(){
      console.log(this.component);
      //this.fields     = [];
      //this.tableData  = [];
      this.title      = this.capitalLetter(this.entity) + " log";
      this.tableName  = this.capitalLetter(this.entity) + " records.";
      this.addAction  = this.addLink;

      this.setBreadcrum();
      //this.getFields();
      //this.getRecords();

      this.fields = this.columns;
      this.tableData = this.datas;
      //this.$forceUpdate();

      if(this.idRecord!=undefined){ this.visible = !this.visible;}
    },

    printItem(item){
      console.log(item);
    },
    openCustomerLocationModal(id=null, item=null, component){
      this.record   = item;
      this.id = id;
      this.$refs['new'+component+"Modal"].show();
    },
    toogle(){
      this.visible = !this.visible;
      this.minimized = !this.minimized;
    }
  }
};
</script>

<template :key="componentKey">
  

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6">
                <h4 class="card-title">
                  <a class="btn btn-xsm secondary">
                    <i v-if=" minimized" class="fas fas fa-chevron-down" v-b-toggle="component" @click="toogle"></i>
                    <i v-if="!minimized" class="fas fas fa-chevron-up" v-b-toggle="component" @click="toogle"></i>
                  </a>
                  {{tableName}}
                </h4>
              </div>
              <div v-if="modalType == 'link'" class="col-lg-6 text-md-right">
                <div>
                  <router-link v-if="idEntity!=undefined" :to="addAction">
                    <span class="btn btn-xsm btn-success"><i class="fas fas fa-plus"></i> Add {{capitalLetter(entity)}}</span>
                  </router-link>
                </div>
              </div>

              <div v-if="modalType == 'modal'" class="col-lg-6 text-md-right">
                <b-button  v-if="idEntity!=undefined" @click="openCustomerLocationModal(null,null,component)" class="btn-xsm" variant="success"><i class="fas fas fa-plus"></i> Add {{capitalLetter(entity)}}</b-button>
                <b-modal
                  id="CustomerLocation"
                  centered
                  title="New"
                  title-class="font-18"
                  hide-footer
                  ref="newCustomerLocationModal"
                >
                  <CustomerLocation
                    :idRecord="id"
                    :idEntity="idEntity"
                    :record="record"
                    @success="closeModal(component)"
                  />
                </b-modal>
                <b-modal
                  id="CustomerContact"
                  centered
                  title="New"
                  title-class="font-18"
                  hide-footer
                  ref="newCustomerContactModal"
                >

                  <CustomerContact
                    :idRecord="id"
                    :idEntity="idEntity"
                    :record="record"
                    @success="closeModal(component)"
                  />
                </b-modal>

                <b-modal
                  id="CategoryMaintenance"
                  centered
                  title="New"
                  title-class="font-18"
                  hide-footer
                  ref="newCategoryMaintenanceModal"
                >
                  <CategoryMaintenance
                    :idRecord="id"
                    :idEntity="idEntity"
                    :record="record"
                    @success="closeModal(component)"
                  />
                </b-modal>

                <b-modal
                  id="CategoryCleaning"
                  centered
                  title="New"
                  title-class="font-18"
                  hide-footer
                  ref="newCategoryCleaningModal"
                >
                  <CategoryCleaning
                    :idRecord="id"
                    :idEntity="idEntity"
                    :record="record"
                    @success="closeModal(component)"
                  />
                </b-modal>

                <b-modal
                  id="CategoryCalibration"
                  centered
                  title="New"
                  title-class="font-18"
                  hide-footer
                  ref="newCategoryCalibrationModal"
                >
                  <CategoryCalibration
                    :idRecord="id"
                    :idEntity="idEntity"
                    :record="record"
                    @success="closeModal(component)"
                  />
                </b-modal>
              </div>
            </div>
            
            <b-collapse id="component" v-model="visible">
              <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show&nbsp;
                      <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  :hover="true"
                  class="table-sm"
                  fixed
                >
                  <template v-slot:cell(actions)="row">
                    <button v-if="actions.view" size="sm" class="mr-1 btn btn-xsm btn-info" @click="$router.push({ name: `${entity}`+'View', params: { id: `${row.item['id_'+entity.replace('-','')]}` } })">
                      <i class="fas fa-eye"></i>
                    </button>
                    <!--
                    <button v-if="actions.edit" size="sm" class="mr-1 btn btn-sm btn-warning" @click="$router.push({ name: `${entity}`+'Edit', params: { id: `${row.item['id_'+entity.replace('-','')]}` } })">
                      <i class="fas fa-edit"></i>
                    </button>
                    -->
                    <button type="button" v-if="actions.edit" size="sm" class="mr-1 btn btn-xsm btn-warning" @click="openCustomerLocationModal(row.item[fields[0]['key']], row.item, component)">
                      <i class="fas fa-edit"></i>
                    </button>
                    <button v-if="user.user.id_role <= 2" size="sm" class="mr-1 btn btn-xsm btn-danger">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                    <!-- info(row.item, row.index, $event.target) -->
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-sm pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
          </b-collapse>
          </div>
        </div>
      </div>
    </div>
  
</template>
<style type="text/css">
.add-button {
  font-family: "Inter", sans-serif !important;
  font-size: 15px !important;
  margin: 0 0 7px 0;
  font-weight: 500;
}
.actionsFixed{
  width: 200px !important;
}
.table thead th {
    vertical-align: middle !important;
}
.btn-xsm {
    padding: 0.15rem 0.25rem;
    font-size: 0.7875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}
</style>